export default {
  nav: {
    Down: "立即下载",
    ReserveGift: "预约好礼",
    CharacterIntroduction: "角色介绍",
    Gameplay: "游戏介绍",
    AttentionFB: "充值特惠",
  },
};
